import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const Awards = () => {
  const { t } = useTranslation();

  return (
    <ImageLoader>
      <Container>
        <Row className="section ">
          <Row className="bottom-padding">
            <Col md={5} className="d-flex flex-column justify-content-center">
              <AnimateOnScroll animationType="slideRight">
                <h2>{t("awards_main_title")}</h2>
                <p>{t("awards_main_p")}</p>
              </AnimateOnScroll>
            </Col>
            <Col md={7} className="d-flex flex-column justify-content-center">
              <AnimateOnScroll animationType="slideLeft">
                <img
                  src="/images/award3.jpg"
                  alt="One Oasis"
                  className="fullimg"
                />
              </AnimateOnScroll>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="d-flex flex-column justify-content-center">
              <AnimateOnScroll animationType="slideLeft">
                <img
                  src="/images/awards_02.jpg"
                  alt="One Oasis"
                  className="fullimg"
                />
              </AnimateOnScroll>
            </Col>
            <Col md={12} className="d-flex flex-column justify-content-center">
              <AnimateOnScroll animationType="slideLeft">
                <img
                  src="/images/awards_01.jpg"
                  alt="One Oasis"
                  className="fullimg"
                />
              </AnimateOnScroll>
            </Col>
          </Row>
        </Row>
      </Container>
    </ImageLoader>
  );
};

export default Awards;
